module.exports = {
      id: "protichinta-logo-usage",
      viewBox: "0 0 205 64",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#protichinta-logo",
      toString: function () {
        return this.url;
      }
    }